import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
// -------------------------------------------------------

const MAX_SPEED = 20;
const ACCELERATION = 0.01;
const EASING = 1.02;
const WAIT_TIME = 600;

class EazyBar extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
    
    this.timer;
    this.start;
    
    addEventListener("drag", (e) => {
      if( e.pageX < 35 ){
        this.timer_set.bind(this)('left', 0);
      } else if( this.state.speed < 0 ){
        this.timer_out.bind(this)();
      }
      
      let diffX = (window.innerWidth - e.pageX);
      if( diffX < 35 ){
        this.timer_set.bind(this)('right', 0);
      } else if( this.state.speed > 0 ){
        this.timer_out.bind(this)();
      }
    });
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      speed       : 0,
      flg         : false,
      speed_type  : '',
    };
  }
  // -------------------------------------------------------
  
  componentDidMount() {
    this.element = document.getElementById('progress-contents');
  }
  // -------------------------------------------------------
  
  timer_set(speed_type, wait) {
    if( this.state.flg == true ) return;
    
    this.start = setTimeout( function(){
      if( this.state.flg == true ){
        this.timer = setInterval(function(){
          this.screen_move.bind(this)();
        }.bind(this), 5);
      }
    }.bind(this), wait);
    
    this.setState({ speed: 0, speed_type: speed_type, flg: true, stop: false });
  }
  // -------------------------------------------------------
  
  timer_out() {
    clearInterval(this.timer);
    clearInterval(this.start);
    if( this.state.flg == false ) return;
    
    this.setState({ speed: 0, flg: false, stop: true });
  }
  // -------------------------------------------------------
  
  move(speed_type) {
    let x = (speed_type == 'left') ? (this.element.scrollLeft - 500) : (this.element.scrollLeft + 500);
    console.log(x);
    this.element.scrollTo({ left: x, behavior: 'smooth' });
    
    clearInterval(this.start);
    this.setState({ speed: 0, flg: false, stop: true });
  }
  // -------------------------------------------------------
  
  screen_move() {
    if( this.state.stop == true ) return;
    
    let speed = this.state.speed;
    speed += (this.state.speed_type == 'left') ? (ACCELERATION * -1) : (ACCELERATION);
    speed = (speed * EASING);
    
    if( speed > MAX_SPEED ) speed = MAX_SPEED;
    if( speed < (MAX_SPEED * -1) ) speed = (MAX_SPEED * -1);
    
    //console.log(speed);
    this.setState({ speed: speed });
    
    document.getElementById('progress-contents').scrollLeft += speed;
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    
    return (
      <div className="eazy-bar-contents">
        <div className="eazy-bar bar-left" onClick={this.move.bind(this, 'left')} onMouseOver={this.timer_set.bind(this, 'left', WAIT_TIME)} onMouseOut={this.timer_out.bind(this)}>
          <i className="material-icons">chevron_left</i>
        </div>
        <div className="eazy-bar bar-right" onClick={this.move.bind(this, 'right')} onMouseOver={this.timer_set.bind(this, 'right', WAIT_TIME)} onMouseOut={this.timer_out.bind(this)}>
          <i className="material-icons">chevron_right</i>
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default EazyBar;